import { defineMessages } from 'react-intl';

export default defineMessages({
	navAriaLabel: {
		id: 'app.components.tabNavLinks.navAriaLabel',
		defaultMessage: 'page section',
		description: 'Page section navigation aria label',
	},
});
